import React from 'react';
import { X, Check } from 'lucide-react';
import {PhoneHQButton} from "ch3-ui-lib";
import PHQAudioPlayer from "../AudioPlayer/PhoneHqAudioPlayer.tsx";

interface VoiceRecordingPreviewProps {
    isRecording: boolean;
    recordingLength: number;
    audioURL: string | null;
    onCancel: () => void;
    onStop?: () => void;
    isSending?: boolean;
    audioLevels: number[];
    maxWidth?: number;
}

const formatRecordingLength = (length: number) => {
    const minutes = Math.floor(length / 60);
    const seconds = length % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

const VoiceRecordingPreview: React.FC<VoiceRecordingPreviewProps> = ({
    isRecording,
    recordingLength,
    audioURL,
    onCancel,
    onStop,
    isSending = false,
    audioLevels,
    maxWidth,
}) => {
    return (
        <div style={maxWidth ? { maxWidth } : undefined}>
            {isRecording && (     <div className="bg-brand rounded-lg p-1">

                <div className="flex items-center gap-1">
                    <PhoneHQButton
                        variant={'secondary'}
                        data-tooltip="Cancel recording"
                        disabled={isSending}
                        className={'px-0'}
                        onClick={onCancel}
                    >
                        <X size={18}/>
                    </PhoneHQButton>
                    <PhoneHQButton
                        variant={'secondary'}
                        data-tooltip="Stop recording"
                        disabled={isSending}
                        className={'px-0'}
                        onClick={onStop}
                    >
                        <Check size={18}/>
                    </PhoneHQButton>
                    <div className="flex flex-1 items-center justify-start gap-[2px] h-10 px-2 overflow-hidden">
                        {audioLevels.map((level, i) => {
                            const height = Math.max(4, level * 32);
                            return (
                                <div
                                    key={i}
                                    className="bg-surface rounded-full transition-all duration-75"
                                    style={{
                                        height: `${height}px`,
                                        width: '2px',
                                        flexShrink: 0,
                                    }}
                                />
                            );
                        })}
                    </div>

                    <span className="text-sm font-mono text-white font-medium whitespace-nowrap px-2">
                        {formatRecordingLength(recordingLength)}
                    </span>
                    {/* D-CHAT-08/S02: the limit; recording stops at 5:00. */}
                    <span className="whitespace-nowrap pr-2 text-[13px] text-white/70">Max 5:00</span>
                </div>
            </div>
            )}
    {!isRecording && audioURL && (
        <div className="mt-2 relative inline-block">
            <PHQAudioPlayer src={audioURL} waveformData={audioLevels} />
            <button
                onClick={onCancel}
                disabled={isSending}
                className="absolute top-1 -right-1 bg-zinc-700 rounded-full hover:bg-zinc-600 transition-colors cursor-pointer z-10"
            >
                <X size={21} color={'white'} />
            </button>
        </div>
    )}
        </div>

    );
};

export default VoiceRecordingPreview;
